import Popper from '@mui/material/Popper';
import { PopperProps } from '@mui/material/Popper/Popper';
import { FC } from 'react';
import { SuggestedCategories } from 'pages/Search/Suggestions/SuggestedCategories';
import { SuggestedKeywords } from 'pages/Search/Suggestions/SuggestedKeywords';
import { SuggestedProducts } from 'pages/Search/Suggestions/SuggestedProducts';
import { IState } from 'pages/Search/types';
import styles from './styles.module.css';

export const SearchPopup: FC<
  PopperProps & {
    state: IState;
    triggerSuggestionEvent?: (value: boolean) => void;
  }
> = ({ open, anchorEl, state, triggerSuggestionEvent, ...props }) => {
  return (
    <Popper
      className={styles.popup}
      open={open}
      anchorEl={anchorEl}
      {...props}
      modifiers={[
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: true,
            tether: true,
            rootBoundary: 'document',
            padding: 8,
          },
        },
      ]}
    >
      <div className={styles.popupRoot}>
        <SuggestedKeywords
          keywords={state.keywords}
          triggerSuggestionEvent={triggerSuggestionEvent as () => void}
          isSmall
        />
        <SuggestedProducts products={state.suggestions?.hits || []} />
        <SuggestedCategories
          categoryList={state.suggestions?.categoryList || []}
        />
      </div>
    </Popper>
  );
};
